import React from "react";
import CheckboxInput from "@/Components/CheckboxInput";
import useInertiaField from "@/Hooks/useInertiaField";

/**
 * Адаптер-компонент для работы с Inertia
 * Если вам не нужно работать с помошником-формой от Inertia, пожалуйста используйте <CheckboxInput /> напрямую
 * @param {string} name - имя поля
 * @param {object} form - объект из useForm (Inertia)
 * @param {object} rest - остальные пропсы
 * @returns {JSX.Element}
 * @constructor
 */
const InertiaCheckboxInput = ({name, form, ...rest}) => {
    if (!name || !form) {
        // MODE - Это встроенная переменная Vite, она доступна всегда ("development" или "production")
        if (import.meta.env.MODE !== 'production') {
            console.warn(
                `<InertiaCheckboxInput /> requires both "name" and "form" props. Received:`,
                {name, form}
            );
        }
        return null;
    }

    const onChange = useInertiaField(name, form);

    return (
        <CheckboxInput
            name={name}
            checked={form.data[name]}
            message={form.errors[name]}
            onChange={onChange}
            {...rest}
        />
    );
}

export default InertiaCheckboxInput;
